import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App as AntApp, ConfigProvider, theme } from 'antd';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          // Distinct from the customer app's per-tenant primary colour: this is
          // a Seiki-internal tool and should never look like a customer's
          // whitelabel, so nobody mistakes one for the other mid-task.
          colorPrimary: '#1f3a5f',
          colorInfo: '#1f3a5f',
          borderRadius: 6,
          fontSize: 14,
          colorText: '#101828',
          colorTextSecondary: '#475467',
          colorBorder: '#d0d5dd',
          colorBorderSecondary: '#eef0f4',
          colorBgLayout: '#f2f4f7',
          controlHeight: 34,
        },
        components: {
          // The chrome is painted by styles.css; these tokens only give antd
          // the same measurements so the two halves line up.
          Layout: {
            headerBg: '#ffffff',
            headerHeight: 56,
            headerPadding: '0 20px 0 12px',
            siderBg: '#0f2138',
            bodyBg: '#f2f4f7',
          },
          Menu: {
            darkItemBg: 'transparent',
            darkSubMenuItemBg: 'transparent',
            darkItemColor: 'rgba(255, 255, 255, 0.72)',
            darkItemHoverBg: 'rgba(255, 255, 255, 0.06)',
            darkItemHoverColor: '#ffffff',
            darkItemSelectedBg: 'rgba(255, 255, 255, 0.12)',
            darkItemSelectedColor: '#ffffff',
            darkGroupTitleColor: 'rgba(255, 255, 255, 0.38)',
            itemHeight: 38,
            itemMarginInline: 8,
            itemBorderRadius: 6,
          },
          Table: {
            headerBg: '#f9fafb',
            headerColor: '#475467',
            headerSplitColor: 'transparent',
            headerBorderRadius: 0,
            borderColor: '#eef0f4',
            rowHoverBg: '#f7f9fc',
            cellPaddingBlock: 11,
            cellPaddingInline: 16,
          },
          Tabs: { horizontalItemPadding: '12px 0', horizontalMargin: '0' },
          Card: { boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)' },
          Drawer: { paddingLG: 20 },
        },
      }}
    >
      <AntApp>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
